export const servicesDetailedData = [
  {
    id: 1,
    title: 'IT Consulting & Support',
    slug: 'it-consulting-support',
    icon: 'Headphones',
    shortDescription: 'Expert guidance and round-the-clock technical support for your IT infrastructure.',
    fullDescription: 'Our IT consulting and support services provide comprehensive assistance for all your technology needs. From strategic planning to day-to-day troubleshooting, our certified experts are available 24/7 to ensure your systems run smoothly. We offer proactive monitoring, incident management, and continuous optimization to keep your business operations uninterrupted.',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800',
    features: [
      '24/7 Technical Support',
      'Remote & On-site Assistance',
      'Proactive System Monitoring',
      'IT Strategy Consulting',
      'Performance Optimization',
      'Issue Resolution & Troubleshooting'
    ],
    benefits: [
      'Minimize downtime and maximize productivity',
      'Access to certified IT professionals',
      'Cost-effective IT management',
      'Scalable support as your business grows'
    ]
  },
  {
    id: 2,
    title: 'AMC Services',
    slug: 'amc-services',
    icon: 'Settings',
    shortDescription: 'Annual maintenance contracts for maximum uptime and predictable IT costs.',
    fullDescription: 'Our Annual Maintenance Contract (AMC) services ensure your IT infrastructure receives regular maintenance, updates, and support throughout the year. With predictable costs and guaranteed response times, you can focus on your core business while we handle all technical aspects. Our AMC packages include preventive maintenance, hardware repairs, software updates, and priority support.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800',
    features: [
      'Scheduled Preventive Maintenance',
      'Hardware & Software Support',
      'Priority Response Times',
      'Regular Health Checks',
      'Spare Parts Management',
      'Performance Reports'
    ],
    benefits: [
      'Predictable IT budgeting',
      'Extended equipment lifespan',
      'Reduced emergency repair costs',
      'Peace of mind with comprehensive coverage'
    ]
  },
  {
    id: 3,
    title: 'CCTV & Security Systems',
    slug: 'cctv-security',
    icon: 'Camera',
    shortDescription: 'End-to-end surveillance design, installation, and monitoring solutions.',
    fullDescription: 'Protect your premises with our state-of-the-art CCTV and security systems. We design, install, and maintain comprehensive surveillance solutions using the latest IP cameras, NVR/DVR systems, and cloud-based monitoring platforms. Our security experts assess your needs and implement customized solutions with features like motion detection, facial recognition, and remote viewing capabilities.',
    image: 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=800',
    features: [
      'IP Camera Installation',
      'NVR/DVR Setup & Configuration',
      'Remote Monitoring Solutions',
      'Motion Detection & Alerts',
      'Cloud Storage Integration',
      '24/7 Surveillance Support'
    ],
    benefits: [
      'Enhanced security and safety',
      'Remote access from anywhere',
      'Deterrent to theft and vandalism',
      'Evidence recording for incidents'
    ]
  },
  {
    id: 4,
    title: 'Networking & Internet',
    slug: 'networking-internet',
    icon: 'Wifi',
    shortDescription: 'High-speed, reliable networking and internet connectivity for businesses.',
    fullDescription: 'Build a robust and scalable network infrastructure with our networking and internet services. We design and implement enterprise-grade networks including LAN, WAN, wireless solutions, and high-speed internet connectivity. Our services cover network planning, installation, configuration, and ongoing management to ensure optimal performance and security for your business operations.',
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800',
    features: [
      'LAN/WAN Network Design',
      'Wireless Network Solutions',
      'High-Speed Internet Setup',
      'Network Security Implementation',
      'VPN Configuration',
      'Network Optimization'
    ],
    benefits: [
      'Reliable and fast connectivity',
      'Secure data transmission',
      'Scalable network architecture',
      'Improved collaboration and productivity'
    ]
  },
  {
    id: 5,
    title: 'Web Design & Development',
    slug: 'web-development',
    icon: 'Code',
    shortDescription: 'Modern, responsive websites and web applications built for results.',
    fullDescription: 'Transform your online presence with our professional web design and development services. We create stunning, responsive websites and powerful web applications tailored to your business needs. Our team specializes in modern frameworks, SEO optimization, and user experience design to deliver websites that not only look great but also drive conversions and achieve your business goals.',
    image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=800',
    features: [
      'Custom Website Design',
      'Responsive Mobile-First Development',
      'E-commerce Solutions',
      'SEO Optimization',
      'CMS Integration',
      'Performance Optimization'
    ],
    benefits: [
      'Professional brand representation',
      'Increased online visibility',
      'Better customer engagement',
      'Higher conversion rates'
    ]
  },
  {
    id: 6,
    title: 'Cloud Hosting Services',
    slug: 'cloud-hosting',
    icon: 'Cloud',
    shortDescription: 'Managed cloud hosting with guaranteed uptime, security, and scalability.',
    fullDescription: 'Move your business to the cloud with our managed hosting services. We provide reliable, scalable, and secure cloud infrastructure using platforms like AWS, Azure, and Google Cloud. Our services include server setup, migration, management, backup solutions, and 24/7 monitoring to ensure your applications and data are always available and protected.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
    features: [
      'AWS, Azure, Google Cloud Setup',
      'Server Migration Services',
      'Auto-scaling Configuration',
      'Load Balancing',
      'Automated Backups',
      '99.9% Uptime Guarantee'
    ],
    benefits: [
      'Reduced infrastructure costs',
      'High availability and reliability',
      'Easy scalability',
      'Enhanced data security'
    ]
  },
  {
    id: 7,
    title: 'IT Hardware & Software Installation',
    slug: 'hardware-software-installation',
    icon: 'HardDrive',
    shortDescription: 'Professional hardware and software installation, configuration, and migration.',
    fullDescription: 'Get expert assistance with all your IT hardware and software installation needs. Our certified technicians handle everything from desktop setups and server installations to enterprise software deployment and data migration. We ensure proper configuration, testing, and documentation for seamless integration with your existing systems.',
    image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800',
    features: [
      'Hardware Installation & Setup',
      'Software Deployment',
      'System Configuration',
      'Data Migration Services',
      'Integration Testing',
      'User Training'
    ],
    benefits: [
      'Professional installation guaranteed',
      'Minimal business disruption',
      'Proper system configuration',
      'Reduced setup time'
    ]
  },
  {
    id: 8,
    title: 'Server Management',
    slug: 'server-management',
    icon: 'Server',
    shortDescription: 'Proactive server monitoring, management, and virtualization services.',
    fullDescription: 'Ensure optimal server performance with our comprehensive management services. We handle server setup, configuration, monitoring, maintenance, and virtualization to keep your critical systems running smoothly. Our proactive approach includes patch management, performance tuning, backup verification, and 24/7 monitoring to prevent issues before they impact your business.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800',
    features: [
      'Server Setup & Configuration',
      '24/7 Monitoring & Alerts',
      'Patch Management',
      'Virtualization (VMware, Hyper-V)',
      'Backup & Disaster Recovery',
      'Performance Optimization'
    ],
    benefits: [
      'Maximum server uptime',
      'Enhanced security with regular updates',
      'Efficient resource utilization',
      'Quick issue resolution'
    ]
  }
];